/***
 * 创建人：ls
 * 时间：2019-07-23
 * 描述：验证输入值的长度
 */
import { Directive } from '@angular/core';
import { AbstractControl } from '@angular/forms';
@Directive({
    selector: '[appValidatorLength]'
})
export class ValidatorLengthDirective {

    constructor() { }

    maxLength(max: number, isHTMLText?: boolean) {
        return (control: AbstractControl) => {
            let v = control.value;
            if (!v || v == "") {
                return null;
            } else {
                // 为富文本类型时，需去掉HTML标签和空格
                if (isHTMLText) {
                    v = v.replace(/<\/?[^>]*>/g, '');  //去除HTML tag;
                    v = v.replace(/[\r\n]/g, '');    //去掉回车换行
                    v = v.replace(/&nbsp;/ig, '');  //去掉空格
                    v = v.replace(/\ +/g, '');  //去掉空格
                }
                if (v.length > max) {
                    return {
                        inputLength: true
                    };
                } else {
                    return null;
                }
            }
        }
    }
}
